import { forwardRef, cloneElement } from 'react';
import { NotificationType } from '../../../typings/notifications.js';
import { Typography } from '../../Typography/Typography.js';
import { getSwitchStyles, getLabelStyles, getCheckboxStyles, getElementStyles, getBarStyles, getToggleStyles, getIconStyles, getTextStyles, getInlineNotificationStyles } from './SwitchStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { InlineNotification } from '../../InlineNotification/InlineNotification.js';

const Switch = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    autoFocus = false,
    'data-id': dataId,
    disabled = false,
    error,
    isChecked,
    children,
    name,
    icon,
    value,
    tabIndex = 0,
    onBlur,
    onChange,
    ...rest
  } = _ref;
  return jsxs("div", {
    css: getSwitchStyles(disabled),
    ref: ref,
    "data-id": dataId,
    ...rest,
    children: [jsxs("label", {
      css: getLabelStyles(disabled, !!error),
      children: [jsx("input", {
        // autoFocus prop will be deprecated
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: autoFocus,
        name: name,
        type: "checkbox",
        onBlur: onBlur,
        value: `${value}`,
        onChange: onChange,
        css: getCheckboxStyles,
        checked: isChecked,
        tabIndex: tabIndex,
        disabled: disabled
      }), jsxs("div", {
        css: getElementStyles,
        "data-id": dataId ? `${dataId}-switch` : undefined,
        children: [jsx("span", {
          css: getBarStyles(isChecked)
        }), jsx("span", {
          css: getToggleStyles(!!error, isChecked),
          className: "switch-toggle",
          children: icon && /*#__PURE__*/cloneElement(icon, {
            css: getIconStyles(isChecked)
          })
        })]
      }), jsx(Typography, {
        variant: "body2",
        css: getTextStyles,
        component: "span",
        children: children
      })]
    }), error && jsx(InlineNotification, {
      css: getInlineNotificationStyles,
      type: NotificationType.ERROR,
      children: error
    })]
  });
});
Switch.displayName = 'Switch';

export { Switch };
//# sourceMappingURL=Switch.js.map
